/* noite inteira · FX-A (JS): 01 lanterna, 05 cockpit, 06 odômetro, 08 régua, 09 busca console */
/* Par do assets/zion-dark-fx.css. Delegação no document (o Horizon remonta header/drawer/busca depois do load). */
(function(){
  if (window.__zionFxA) return; window.__zionFxA = 1;
  var mq = function(q){ return !!(window.matchMedia && matchMedia(q).matches); };
  var calmo = mq('(prefers-reduced-motion: reduce)');
  var mouse = function(){ return mq('(hover: hover) and (pointer: fine)'); };

  /* scroller certo: >=990px rola a .page-wrapper (html/body overflow hidden); no celular, o documento */
  var SQ = window.matchMedia ? matchMedia('(min-width: 990px)') : {matches: false};
  function scroller(){
    if (!SQ.matches) return document.scrollingElement || document.documentElement;   /* <990px o documento rola (mesma regra do scroll-container.js do Horizon): sem ler scrollHeight do .page-wrapper a cada quadro */
    var pw = document.querySelector('.page-wrapper');
    return (pw && pw.scrollHeight > pw.clientHeight + 5) ? pw : (document.scrollingElement || document.documentElement);
  }
  /* 1 leitura por quadro para tudo que depende de rolagem (05 e 08) */
  var tickers = [], rq = 0;
  function tick(){ rq = 0; for (var i = 0; i < tickers.length; i++){ try { tickers[i](); } catch (e) {} } }
  function pede(){ if (!rq) rq = requestAnimationFrame(tick); }
  function onScroll(fn){
    if (!tickers.length){
      document.addEventListener('scroll', pede, {capture: true, passive: true});
      var W0 = innerWidth;   /* resize só quando a LARGURA muda (a barra de endereço do celular dispara resize em plena rolagem); pede() já agenda em 1 rAF */
      addEventListener('resize', function(){ if (innerWidth !== W0){ W0 = innerWidth; pede(); } }, {passive: true});
    }
    tickers.push(fn); pede();
  }

  /* ===== 01 LANTERNA ===== */
  try {
    var LAMP = '.product-card, .product-information__media .product-media-container, .zion-dest';
    var alvo = null, px = 0, py = 0, rl = 0;
    var pinta = function(){ rl = 0; if (!alvo) return;
      var r = alvo.getBoundingClientRect(); if (!r.width || !r.height) return;
      alvo.style.setProperty('--zfx-x', ((px - r.left) / r.width * 100).toFixed(1) + '%');
      alvo.style.setProperty('--zfx-y', ((py - r.top) / r.height * 100).toFixed(1) + '%');
    };
    var troca = function(t){
      if (t === alvo) return;
      if (alvo) alvo.classList.remove('zfx-lit');
      alvo = t;
      if (alvo){
        /* entra com a luz já no ponto de entrada (sem viagem desde o centro) */
        var r = alvo.getBoundingClientRect();
        if (r.width && r.height){
          alvo.style.setProperty('--zfx-x', ((px - r.left) / r.width * 100).toFixed(1) + '%');
          alvo.style.setProperty('--zfx-y', ((py - r.top) / r.height * 100).toFixed(1) + '%');
        }
        alvo.classList.add('zfx-lit');
      }
    };
    document.addEventListener('pointermove', function(e){
      if (e.pointerType !== 'mouse' || !mouse()) return;
      px = e.clientX; py = e.clientY;
      troca(e.target && e.target.closest ? e.target.closest(LAMP) : null);
      if (alvo && !rl) rl = requestAnimationFrame(pinta);
    }, {passive: true});
    document.addEventListener('pointerout', function(e){ if (!e.relatedTarget) troca(null); }, {passive: true});
  } catch (e) {}

  /* ===== 05 COCKPIT (barra fixa da PDP: .zion-sticky, movida para o <body> pelo script do produto) ===== */
  try {
    if (document.querySelector('[data-zion-sticky]')){
      var pulsou = false, mx = -1, mxT = 0, lastP = '';
      var inv = function(){ mx = -1; };   /* altura rolável em cache: scrollHeight/clientHeight forçam layout a cada quadro; só mudam quando o documento muda de tamanho */
      /* 19/10 (teste no ar): ResizeObserver no body disparava "ResizeObserver loop completed" no Safari do iPhone (o body muda de tamanho o tempo todo);
         no lugar dele a altura é relida no máximo 1x por segundo durante a rolagem */
      addEventListener('resize', inv, {passive: true}); addEventListener('load', inv);
      onScroll(function(){
        var bar = document.querySelector('body > [data-zion-sticky]') || document.querySelector('[data-zion-sticky]');
        if (!bar) return;
        var sc = scroller(), agora = Date.now(); if (mx < 0 || agora - mxT > 1000){ mx = sc.scrollHeight - sc.clientHeight; mxT = agora; } var max = mx;
        var pv = max > 0 ? Math.min(1, Math.max(0, sc.scrollTop / max)).toFixed(4) : '0';
        if (pv !== lastP){ lastP = pv; bar.style.setProperty('--zfx-p', pv); }
        if (!pulsou && !calmo && bar.classList.contains('is-on')){
          pulsou = true;
          var cta = bar.querySelector('.button:not(.zion-sticky__add)') || bar.querySelector('.button');
          if (cta){
            cta.classList.add('zfx-pulse');
            cta.addEventListener('animationend', function(){ cta.classList.remove('zfx-pulse'); }, {once: true});
          }
        }
      });
    }
  } catch (e) {}

  /* ===== 06 ODÔMETRO (preço principal, Pix e barra fixa) =====
     O script do produto escreve o preço com textContent e só quando o texto muda. Aqui cada dígito vira um <zfx-d> (tag própria: regra "X span" do tema não pega) com o
     MESMO dígito como texto: o textContent não muda, então nenhum dos dois scripts entra em laço. */
  try {
    if (!calmo && document.querySelector('[data-zion-preco]') && 'IntersectionObserver' in window){
      var ODO = '.zion-price [data-zq="pix"], .zion-price [data-zq="price"]';   /* 05/10/2026 (onda 1): fora da barra fixa — lá o preço rolava por valores errados a cada aparição */
      var memo = {}, visto = new WeakSet(), vivos = new WeakSet();
      var chave = function(el){ return el.getAttribute('data-zq') + (el.closest('.zion-sticky') ? '@s' : '@m'); };
      var digitos = function(s){ return s.replace(/\D/g, ''); };
      var monta = function(el, de){
        var t = el.textContent, html = '', dg = digitos(t), dd = digitos(de || ''), k = 0, n = dg.length;
        for (var i = 0; i < t.length; i++){
          var c = t.charAt(i);
          if (c >= '0' && c <= '9'){
            /* origem alinhada pela direita (centavos com centavos); sem valor anterior, rola desde 0 */
            var j = dd.length - (n - k), o = j >= 0 ? dd.charAt(j) : '0';
            html += '<zfx-d style="--d:' + o + ';--dl:' + (k * 45) + 'ms">' + c + '</zfx-d>'; k++;
          } else html += c === '<' ? '&lt;' : c === '&' ? '&amp;' : c;
        }
        el.__zfx = t; memo[chave(el)] = t;
        el.innerHTML = html;
        /* INP: antes `void el.offsetWidth` forçava recálculo de estilo síncrono dentro do clique (+/− da quantidade); rAF duplo garante o quadro do estado inicial sem forçar */
        requestAnimationFrame(function(){ requestAnimationFrame(function(){
          var ds = el.querySelectorAll('zfx-d');
          for (var m = 0; m < ds.length; m++) ds[m].style.setProperty('--d', ds[m].textContent);
        }); });
      };
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){
          if (!e.isIntersecting) return; io.unobserve(e.target); vivos.add(e.target);
          /* 05/10/2026: na 1ª aparição o preço fica parado (rolar desde 0 passava por valores falsos); só rola quando o valor MUDA (variante/quantidade) */
          var k = chave(e.target);
          if (memo[k] && memo[k] !== e.target.textContent) monta(e.target, memo[k]); else { e.target.__zfx = e.target.textContent; memo[k] = e.target.__zfx; }
        });
      });
      var varre = function(){
        document.querySelectorAll(ODO).forEach(function(el){
          if (!visto.has(el)){ visto.add(el); io.observe(el); return; }
          if (!vivos.has(el)) return;
          var t = el.textContent;
          if (t !== el.__zfx) monta(el, el.__zfx);
        });
      };
      var rv = 0;
      new MutationObserver(function(){ if (!rv) rv = requestAnimationFrame(function(){ rv = 0; varre(); }); })
        .observe(document.body, {childList: true, subtree: true, characterData: true});
      varre();
    }
  } catch (e) {}

  /* ===== 08 RÉGUA DE LEITURA (artigo) ===== */
  try {
    if (document.querySelector('.zion-art .zion-art__body')){
      var regua = document.createElement('div');
      regua.className = 'zfx-ruler'; regua.setAttribute('aria-hidden', 'true');
      document.body.appendChild(regua);
      var ativo = null;
      onScroll(function(){
        var body = document.querySelector('.zion-art .zion-art__body'); if (!body) return;
        if (!regua.isConnected) document.body.appendChild(regua);
        var hd = document.querySelector('#header-component'), top = 0;
        if (hd){ var hr = hd.getBoundingClientRect(); top = Math.max(0, Math.round(hr.bottom)); }
        var vh = innerHeight, r = body.getBoundingClientRect();
        var total = r.height - (vh - top), p = total > 0 ? (top - r.top) / total : (r.top < top ? 1 : 0);
        regua.style.setProperty('--zfx-top', top + 'px');
        regua.style.setProperty('--zfx-p', Math.min(1, Math.max(0, p)).toFixed(4));
        /* intertítulo atual = o último h2 que já passou de 30% da tela (mesma faixa do índice "Neste guia") */
        var hs = body.querySelectorAll('h2[id]'), cur = null, linha = top + (vh - top) * .3;
        for (var i = 0; i < hs.length; i++){ if (hs[i].getBoundingClientRect().top <= linha) cur = hs[i]; else break; }
        if (cur !== ativo){
          if (ativo) ativo.classList.remove('zfx-on');
          ativo = cur;
          if (ativo) ativo.classList.add('zfx-on');
          /* o índice já tem destaque por aria-current (script do artigo, IntersectionObserver); aqui só alinha com o h2 */
          document.querySelectorAll('.zion-art__toc a, .zion-art__tocm a').forEach(function(a){
            a.toggleAttribute('aria-current', !!ativo && a.getAttribute('href') === '#' + ativo.id);
          });
        }
      });
    }
  } catch (e) {}

  /* ===== 09 BUSCA COMO CONSOLE (desktop) =====
     1–5 = território (só com o campo vazio ou fora de um campo). ↑/↓/Enter nos resultados já são do Horizon
     (aria-selected + .keyboard-focus, o CSS dá o foco visível); aqui ↑/↓ cobrem os "Vistos recentemente" da Zion. */
  try {
    var visivel = function(el){ return !!(el && el.getClientRects().length); };
    document.addEventListener('keydown', function(e){
      if (e.defaultPrevented || e.ctrlKey || e.metaKey || e.altKey || !mouse() || !mq('(min-width: 990px)')) return;
      var modal = document.querySelector('.search-modal'); if (!modal) return;
      var chips = [].filter.call(modal.querySelectorAll('.zion-search__chip'), visivel);
      if (!chips.length && !visivel(modal.querySelector('.zion-search__rv'))) return;
      var a = document.activeElement;
      var campo = a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA' || a.isContentEditable);
      if (/^[1-5]$/.test(e.key)){
        if (campo && a.value) return;
        var chip = chips[+e.key - 1]; if (!chip) return;
        e.preventDefault(); chip.click(); return;
      }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      if (modal.querySelector('.predictive-search-results__card')) return;
      var ls = [].filter.call(modal.querySelectorAll('.zion-search__rvcard .resource-card__link'), visivel);
      if (!ls.length) return;
      var i = ls.indexOf(a), d = e.key === 'ArrowDown' ? 1 : -1;
      i = i < 0 ? (d > 0 ? 0 : ls.length - 1) : (i + d + ls.length) % ls.length;
      e.preventDefault(); ls[i].focus();
    }, true);
  } catch (e) {}
})();
/* degradê da PDP no celular: o escuro vai até o fim do título do produto (--zt), depois o marrom assume */
(function(){try{
  var mq=window.matchMedia('(max-width:749px)');
  var last='',W=innerWidth;   /* só grava --zt na raiz se o valor mudou; resize só se a largura mudou (barra de endereço dispara resize e a variável na raiz invalida o estilo do documento) */
  function set(){var h=document.querySelector('.product-information h1, main h1.zion-h1');if(!h)return;
    var y=h.getBoundingClientRect().bottom+(window.scrollY||document.documentElement.scrollTop||0);
    var v=Math.round(y)+'px';if(v===last)return;last=v;
    document.documentElement.style.setProperty('--zt',v);}
  function run(){if(mq.matches)set();}
  document.addEventListener('DOMContentLoaded',run);window.addEventListener('load',run);window.addEventListener('resize',function(){if(innerWidth===W)return;W=innerWidth;run();});
  if(window.ResizeObserver){document.addEventListener('DOMContentLoaded',function(){var m=document.querySelector('.product-information');if(m)new ResizeObserver(run).observe(m);});}
}catch(e){}})();
